import React from 'react';
import { number } from 'prop-types';
import CollectWrapper from './CollectWrapper';
import AvailableServices from './AvailableServices';

import './style.scss';

const Footer = ({ id, gigsCount = 0 }) => {
    const showAvailableServices = gigsCount > 0;

    return (
        <footer>
            <CollectWrapper sellerId={id} />
            {showAvailableServices && <AvailableServices sellerId={id} total={gigsCount} />}
        </footer>
    );
};

Footer.propTypes = {
    id: number,
    gigsCount: number,
};

export default Footer;
